import React from 'react';
import PropTypes from 'prop-types';
import Link from '../LinkWithCountry/LinkWithCountry';
import withExperiment from '../ExperimentGate/withExperiment';

const HeaderSignInRewardsLink = ({
  to,
  signInButtonStyleChange,
  signInButtonText,
  moduleStyles,
  color,
}) => {
  const pinkClass = color === 'pink' ? moduleStyles.signInButtonPink : '';

  return (
    <Link
      to={to}
      className={`${moduleStyles.button} ${pinkClass} ${
        signInButtonStyleChange ? moduleStyles.signInButton : 'text-sm'
      }`}
    >
      {signInButtonText}
    </Link>
  );
};

HeaderSignInRewardsLink.propTypes = {
  to: PropTypes.string.isRequired,
  signInButtonStyleChange: PropTypes.bool.isRequired,
  signInButtonText: PropTypes.string.isRequired,
  moduleStyles: PropTypes.shape({
    button: PropTypes.string.isRequired,
    signInButton: PropTypes.string.isRequired,
    signInButtonPink: PropTypes.string.isRequired,
  }).isRequired,
  color: PropTypes.oneOf(['pink', 'yellow']),
};

HeaderSignInRewardsLink.defaultProps = {
  color: 'yellow',
};

export { HeaderSignInRewardsLink };

export default withExperiment('signInButtonColor', ({ variant }) => ({
  color: variant,
}))(HeaderSignInRewardsLink);
